let UTILS = require("../libs/utils.js");
var v6657;
var v6658;
module.exports = {
  id: "tdm",
  name: "Team Deathmatch",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists", "reward"],
  alias: "tdm",
  teams: true,
  leaderStats: ["score", "kills", "deaths"],
  description: "It’s you and your team.\nEliminate the other team players.\nTeam with highest score, wins.",
  descriptionLang: "game.mode.tdm.description"
};